import React from 'react';
import { SVGOverlay } from 'react-leaflet';
import CustomMarker from "./CustomMarker";

const Cluster = (props) => {
    const { mapElements, redirectRoute, currentZoom, isOverview, plannerHorseback } = props
    return (
      <span>
        {mapElements.clusters != undefined &&
          mapElements.clusters.map((cluster, index) => {
            return (
              <SVGOverlay key={index} bounds={cluster.bounds} className="">
                <circle
                  r="52"
                  cx="50%"
                  cy="50%"
                  className="c-custom-cluster animate pop"
                />
                <text
                  dominantBaseline="middle"
                  textAnchor="middle"
                  x="50%"
                  y="50%"
                  stroke="white"
                  className="animate pop"
                >
                  {cluster.total}
                </text>
              </SVGOverlay>
            );
          })}

        {mapElements.routes != undefined &&
          mapElements.routes.map((route) => {
            return (
              <CustomMarker
                className="animate bounce"
                key={route.id}
                id={route.id}
                position={route.position}
                source={route.source}
                redirectRoute={redirectRoute}
                currentZoom={currentZoom}
                name={route.name}
                isOverview={isOverview}
              />
            );
          })}
      </span>
    );
}

export default Cluster;